module.exports = __webpack_public_path__ + "static/media/blog.515909f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blog.jpg
// module id = 403
// module chunks = 17